<script>
export default {
  props: {
    turnstileInfo: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    openLink(url) {
      window.open(url, '_blank')
    },
    hidePreview () {
      this.$emit('hidePreview')
    }
  }
}
</script>
<template>
  <div class="turnstile-preview bg-black py-5 px-4">
    <div
      v-if="turnstileInfo.turnstile_type === 0"
      class="turnstile-preview__container"
    >
      <h1 class="text-center text-white title mb-5">{{
       turnstileInfo.form_title
      }}</h1>
      <form action="" class="mb-5">
        <div class="form-content">
          <div class="row">
            <div
              v-if="turnstileInfo.ask_name"
              class="form-group__name col-sm-12"
            >
              <div class="form-group">
                <BaseInputText
                  v-model="turnstileInfo.name"
                  name="name"
                  type="text"
                  :placeholder="'Full Name'"
                />
              </div>
            </div>

            <div class="form-group col-sm-12">
              <div class="d-flex alignt-items-center">
                <input
                  v-model="turnstileInfo.email"
                  type="text"
                  name="email"
                  class="form-control form-control--email bg-white _base-input"
                  placeholder="Email"
                />
                <div class="input-group-append">
                  <div
                    class="input-group-text bg-secondary border-secondary align-items-center d-flex h-100"
                  >
                    <p class="text-white m-0 h5 px-4">{{
                     turnstileInfo.button_text
                    }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <h5 class="text-center text-white mb-3">{{
       turnstileInfo.form_subtitle
      }}</h5>

      <h6
        v-if="turnstileInfo.allow_skip"
        class="text-white text-center"
        @click.prevent="hidePreview"
        >You can
        <span class="text-underline"
          >skip this form</span
        >
        and continue watching your video</h6
      >
    </div>

    <div
      v-else-if="turnstileInfo.turnstile_type === 1"
      class="turnstile-preview__container"
    >
      <form action="" class="mb-5">
        <div class="form-content">
          <div
            v-for="(item, index) in turnstileInfo.turnstile_links" :key="index"
            class="row"
          >
            <div
              class="form-group col-sm-12 align-item-center"
            >
              <div
                class="d-flex alignt-items-center input-group-append"
              >
                <button
                  class="input-group-text bg-secondary border-secondary align-items-center d-flex h-100 d-block mx-auto"
                  @click.prevent="openLink(item.url)"
                >
                  <div>
                    <p class="text-white m-0 h5 px-4">
                      {{ item.title }}
                    </p>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <h6
        v-if="turnstileInfo.allow_skip"
        class="text-white text-center"
        >You can
        <span class="text-underline"
          >skip this button</span
        >
        and continue watching your video</h6
      >
    </div>
  </div>
</template>
